<style lang="scss" scoped>
.settings {
    @include container();
    &__section {
        padding-bottom: 70px;
        border-bottom: 1px solid #eee;
        margin-bottom: 30px;
        &:last-child {
            margin-bottom: 0;
            border-bottom: 0;
        }
    }
    &__year {
        margin-left: 20px;
    }
    &__row {
        @include grid();
    }
    &__left {
        @include grid-col(4);
        padding-right: 40px;
    }
    &__right {
        @include grid-col(8);
    }
    &__pad-bottom {
        margin-bottom: 30px;
    }
    &__pad-right {
        padding: 20px;
    }
    &__border-bottom {
        border-bottom: 1px solid #eee;
    }
    & ::v-deep .el-cascader {
        width: 100%;
    }
    & ::v-deep .el-select {
        width: 100%;
    }
    .warning a {
        color: #eb4335 !important;
        font-weight: bold;
    }
    .preview {
        margin: 0;
    }

    .d-block {
        display:block;
        line-height:1;
        
    }
    .d-block ~ span, .warning-text {
            margin-bottom:50px;
            font-size:13px;
            color:red
        }

    &__supplementary-text {
        font-size: 12px;
        line-height: 1.3;
        padding-bottom: 10px;
    }

    .dashboardTiles {
        display:flex;
        flex-wrap: wrap;
        & div {
            & .dashboardTiles-item {
                min-width: 160px;
                margin: 10px 10px 0 0;
            }
        }
    }

}

</style>
<template lang="pug">
.settings
    .main-panel
        loading(v-if="!form && $apollo.loading")
        template(v-else-if="form")
            .main-panel__padding.settings__section(v-if="providerCode == 'apl'")
                .settings__row
                    .settings__left
                        h2 Organisation
                    .settings__right
                        el-card.box-card.settings__pad-bottom
                            el-form(label-position="top")
                                custom-field-format(
                                            v-model="form.location_id_format",
                                            fieldLabel="Location ID format",
                                            :fieldNames="fieldNames.location",
                                            :dbFields="dbFields.location",
                                            settingKey="location_id_format",
                                            type="organisation"
                                )
                                custom-field-format(
                                    v-model="form.location_name_format",
                                    fieldLabel="Location name format",
                                    :fieldNames="fieldNames.location",
                                    :dbFields="dbFields.location",
                                    settingKey="location_name_format"
                                )
                                el-form-item(label="Password policy")
                                    el-select(v-model="form.password_policy")
                                        el-option(v-for="(item,i) in passwordPolicies" :key="i" :label="item.label" :value="item.value" )
                                el-form-item(label="Automated sync time")
                                    el-time-picker(v-model="form.auto_sync_time" :picker-options="{ selectableRange: '00:00:00 - 23:59:59', format: 'HH:mm' }" placeholder="Select time")
            .main-panel__padding.settings__section
                .settings__row
                    .settings__left
                        h2 Domains 
                            span(v-if="providerCode !== 'apl'") and {{ orgUnitLabel.acronym }}’s
                    .settings__right
                        el-card.box-card.settings__pad-bottom
                            .clearfix(slot="header")
                                span Students
                            el-form(label-position="top")
                                el-form-item(label="Student domain")
                                    el-select(v-if="providerCode == 'gapps'", name="format", v-model="form.domain", placeholder="Select")
                                        el-option(v-for="item in domains", :key="item.id", :label="item.id", :value="item.id")
                                    el-input(v-else, size="medium", v-model="form.domain", placeholder="Student domain name")
                                div(v-if="features.ou")
                                    el-form-item(:label="'Which ' + orgUnitLabel.name + ' do you want to use to create and manage students?'")
                                        organisation-selector(v-model="form.student_org_unit_id")
                                    student-ou-structure(v-if="features.ou_structure", v-model="form.student_org_unit_structure")
                        el-card.box-card
                            .clearfix(slot="header")
                                span Staff
                            el-form(label-position="top")
                                el-form-item(label="Staff domain")
                                    el-select(v-if="providerCode == 'gapps'", name="format", v-model="form.domain_employee", placeholder="Select")
                                        el-option(v-for="item in domains", :key="item.id", :label="item.id", :value="item.id")
                                    el-input(v-else, size="medium", v-model="form.domain_employee", placeholder="Staff domain name")
                                div(v-if="features.ou")
                                    el-form-item(:label="'Which ' + orgUnitLabel.name + ' do you want to use to create and manage staff?'")
                                        organisation-selector(v-model="form.employee_org_unit_id")
            .main-panel__padding.settings__section
                .settings__row
                    h2 Default Organisation Rules
                .settings__row
                    .settings__left
                        h2.mt-3 Rules
                        p Control which students and staff are synced using filter rules.
                    .settings__right
                        student-rules.settings__pad-bottom(:isOrganisation="true", v-model="student_rule_object")
                        employee-rules(v-model="employee_rule_object")
            .main-panel__padding.settings__section
                .settings__row
                    .settings__left
                        h2.mt-3 Account management
                    .settings__right
                        el-card.settings__pad-bottom
                            .clearfix(slot="header")
                                span Account creation
                            el-form(label-position="top")
                                template
                                    div.settings__pad-bottom
                                        el-form-item(label="Student Person ID")
                                            el-select(v-model="form.student_id_field")
                                                el-option(v-for="(item,i) in personIdOptions.student" :key="i" :label="item.label" :value="item.value" )
                                            span.warning-text(v-if="form.student_id_field !== 'edusync_id'") Only use this if the ID is unique across all your users regardless of type to avoid missing users due to conflict
                                        el-form-item(label="Employee Person ID")
                                            el-select(v-model="form.employee_id_field")
                                                el-option(v-for="(item,i) in personIdOptions.employee" :key="i" :label="item.label" :value="item.value" )
                                            span.warning-text(v-if="form.employee_id_field !== 'edusync_id'") Only use this if the ID is unique across all your users regardless of type to avoid missing users due to conflict
                                        el-form-item(label="Student email account creation")
                                            el-select(v-model="form.email_account_creation_option_student")
                                                el-option(v-for="(item,i) in userEmailAccountCreationOptions.student" :key="i" :label="item.label" :value="item.value" )
                                        el-form-item(label="Staff email account creation")
                                            el-select(v-model="form.email_account_creation_option_employee")
                                                el-option(v-for="(item,i) in userEmailAccountCreationOptions.employee" :key="i" :label="item.label" :value="item.value" )
                        el-card.settings__pad-bottom
                            .clearfix(slot="header")
                                span Account deactivation
                            el-form(label-position="top")
                                el-form-item
                                    el-radio(v-model="form.deletion_mode_student", label="auto", border="", size="medium") Automatically with Edusync {{ providerName }}
                                    el-radio(v-model="form.deletion_mode_student", label="self", border="", size="medium") Manually within {{ providerName }} School Manager
                                template(v-if="form.deletion_mode_student == 'auto'")
                                    el-form-item(label="Deactivate student accounts after")
                                        el-input-number(:min="0", :max="365", size="medium", v-model="form.suspend_delay_student", e2e="suspend_days")
                                        |
                                        | {{ form.suspend_delay_student == 1 ? 'day' : 'days' }}
                                        <br>
                                        span.warning-text Staff will be automatically deactivated according to their leaving date in your MIS
            .main-panel__padding.settings__section
                .settings__row
                    .settings__left
                        h2.mt-3 Emails
                    .settings__right
                        el-card.settings__pad-bottom
                            .clearfix(slot="header")
                                span User emails
                            el-form(label-position="top")
                                template
                                    div.settings__pad-bottom
                                        div.settings__pad-bottom
                                            el-radio(v-model="form.student_use_mis_email", :label="false", border="") Generate student emails
                                            el-radio(v-model="form.student_use_mis_email", :label="true", border="") Use {{ misLabel }} student emails
                                        el-form-item.settings__pad-bottom(label="Student email format (naming convention)" v-if="!form.student_use_mis_email")
                                            el-select(name="format", v-model="form.email_format_student", placeholder="Select")
                                                el-option(v-for="item in email_formats.student", :key="item.value", :label="item.label", :value="item.value")
                                        el-form-item(label="Student email" v-else)
                                            el-select(v-model="form.email_field_student")
                                                el-option(v-for="(item,i) in userEmailOptions" :key="i" :label="item.label" :value="item.value")
                                    div.settings__pad-bottom
                                        div.settings__pad-bottom
                                            el-radio(v-model="form.employee_use_mis_email", :label="false", border="") Generate staff emails
                                            el-radio(v-model="form.employee_use_mis_email", :label="true", border="") Use {{ misLabel }} staff emails
                                        el-form-item(label="Staff email format (naming convention)" v-if="!form.employee_use_mis_email")
                                            el-select(name="format", v-model="form.email_format_employee", placeholder="Select")
                                                el-option(v-for="item in email_formats.employee", :key="item.value", :label="item.label", :value="item.value")
                                        el-form-item(label="Employee email" v-else)
                                            el-select(v-model="form.email_field_employee")
                                                el-option(v-for="(item,i) in userEmailOptions" :key="i" :label="item.label" :value="item.value")
            .main-panel__padding.settings__section
                .settings__row
                    .settings__left
                        h2.mt-3 Classes and Courses
                    .settings__right
                        el-card.settings__pad-bottom
                            .clearfix(slot="header")
                                span Classes
                            el-form(label-position="top")
                                template
                                    div.settings__pad-bottom
                                        custom-field-format(
                                            v-model="form.class_id_format",
                                            fieldLabel="Class ID format",
                                            :fieldNames="fieldNames.class",
                                            :dbFields="dbFields.class",
                                            settingKey="class_id_format",
                                            type="organisation"
                                        )
                        el-card.settings__pad-bottom
                            .clearfix(slot="header")
                                span Courses
                            el-form(label-position="top")
                                template
                                    div.settings__pad-bottom
                                        custom-field-format(
                                            v-model="form.course_id_format",
                                            fieldLabel="Course ID format",
                                            :fieldNames="fieldNames.course",
                                            :dbFields="dbFields.course",
                                            settingKey="course_id_format",
                                            type="organisation"
                                        )
                                        custom-field-format(
                                            v-model="form.course_name_format",
                                            fieldLabel="Course name format",
                                            :fieldNames="fieldNames.course",
                                            :dbFields="dbFields.course",
                                            settingKey="course_name_format",
                                            type="organisation"
                                        )
                        el-card.settings__pad-bottom
                            .clearfix(slot="header")
                                span Rosters
                            el-form(label-position="top")
                                template
                                    div.settings__pad-bottom
                                        custom-field-format(
                                            v-model="form.roster_id_format",
                                            fieldLabel="Roster ID format",
                                            :fieldNames="fieldNames.roster",
                                            :dbFields="dbFields.roster",
                                            settingKey="roster_id_format",
                                            type="organisation"
                                        )
            .main-panel__padding.settings__section
                .settings__row
                    .settings__left
                        h2.mt-3 Apple School Manager connection
                    .settings__right
                        el-card.settings__pad-bottom
                            .clearfix(slot="header")
                                span SFTP Access Details
                            el-form(label-position="top")
                                template
                                    el-form-item(label="Host")
                                        el-input(size="medium", v-model="form.sftp_host")
                                    el-form-item(label="Username")
                                        el-input(size="medium", v-model="form.sftp_username")
                                    el-form-item(label="Password")
                                        el-input(type="password", size="medium", v-model="form.sftp_password")

        slot(name="footer")
</template>
<script>
import gql from "graphql-tag";
import _ from "lodash";
import moment from "moment";
import StudentRules from "./../includes/StudentRules";
import EmployeeRules from "./../includes/EmployeeRules";
import CustomFieldFormat from './../../includes/CustomFieldFormat';

export default {
    components: {
        StudentRules,
        EmployeeRules,
        CustomFieldFormat,
    },

    computed: {
        domain () {
            return this.form.domain_employee || this.form.domain
        }
    },

    apollo: {
        domains: {
            query: gql`
                {
                    Domains(verified: true) {
                        id
                        primary
                        verified
                    }
                }
            `,
            update: (r) => r.Domains,
        },
        previewUser: {
            query: gql`
                {
                    User {
                        first_name
                        last_name
                    }
                }
            `,
            update: (r) => r.User,
        },
        form: {
            query: gql`
                query Settings($type: SettingsTypeEnum!) {
                    Settings(type: $type) {
                        id
                        deletion_mode_student
                        student_active
                        email_format_employee
                        email_format_student
                        domain
                        domain_employee
                        employee_active
                        sftp_host
                        sftp_port
                        sftp_username
                        sftp_password
                        password_policy
                        auto_sync_time
                        email_formats
                        suspend_delay_student
                        student_id_field
                        employee_id_field
                        student_use_mis_email
                        employee_use_mis_email
                        course_id_format
                        course_name_format
                        class_id_format
                        email_field_employee
                        email_field_student
                        roster_id_format
                        location_id_format
                        location_name_format
                        email_account_creation_option_employee
                        email_account_creation_option_student
                    }
                }
            `,
            variables() {
                return {
                    type: "organisation"
                }
            },
            fetchPolicy: "no-cache",
            update(r) {
                let settings = _.cloneDeep(r.Settings);
                this.student_rule_object.active = _.cloneDeep(settings.student_active);
                delete settings.student_provision_rules;
                delete settings.student_active;
                this.employee_rule_object.active = _.cloneDeep(settings.employee_active);
                delete settings.employee_active;
                settings.auto_sync_time = moment.utc(settings.auto_sync_time, "HH:mm").local();

                return settings;
            },
        },
        school: {
            query: gql`
                {
                    School {
                        name
                        phase_of_education
                    }
                }
            `,
            update: (r) => r.School,
        },
    },
    computed: {
        email_formats() {
            if (this.previewUser && this.form) {
                const studentFormats = _.map(this.form.email_formats, formatString => this.calcFormatsWithLabels(formatString, this.form.domain));
                const employeeDomain = this.form.domain_employee || this.form.domain;
                const employeeFormats = _.map(this.form.email_formats, formatString => this.calcFormatsWithLabels(formatString, employeeDomain));
                
                return { student: studentFormats, employee: employeeFormats };
            } else {
                return [];
            }
        },
    },

    methods: {
        save() {
            this.loading = true;
            this.$emit("Saving", this.loading);

            let insert = _.pickBy(this.form, (value, key) => {
                return key !== "__typename" && key !== "id" && key !== "email_formats";
            });

            insert = {
                ...insert,
                sftp_password: this.form.sftp_password ? this.form.sftp_password : null,
                auto_sync_time: moment.utc(this.form.auto_sync_time).format("HH:mm:ss"),
                student_active: this.student_rule_object.active,
                employee_active: this.employee_rule_object.active
            }
    
            this.$apollo
                .mutate({
                    mutation: gql`
                        mutation SaveSettings($object: SettingsInput!, $type: SettingsTypeEnum) {
                            SaveSettings(object: $object, type: $type) {
                                deletion_mode_student
                                student_active
                                email_format_employee
                                email_format_student
                                domain
                                domain_employee
                                employee_active
                                sftp_host
                                sftp_port
                                sftp_username
                                sftp_password
                                password_policy
                                auto_sync_time
                                suspend_delay_student
                            }
                        }
                    `,
                    variables: {
                        object: insert,
                        type: "organisation"
                    },
                })
                .then((r) => {
                    this.loading = false;
                    this.$emit("Saving", this.loading);
                    this.$emit("Saved");
                    this.$message.success("Settings saved");
                    this.$root.$emit("directory-reload-required");
                })
                .catch((e) => {
                    this.loading = false;
                    this.$emit("Saving", this.loading);
                    this.$message.error("Failed to update settings");
                });
        },
        calcFormatsWithLabels (formatString, domain, extra = "")  {
            // Display data
            const first_name = _.deburr(this.previewUser.first_name),
            mis_id = 'ABC123',
            first_name_letters = first_name ? first_name.split("") : [""],
            last_name = _.deburr(this.previewUser.last_name),
            last_name_letters = last_name ? last_name.split("") : [""],
            number = '2',
            cohort_year = 2015,
            education_details = {
                admission_number: "123456789",
                learner_number: "123456",
                admission_date: moment(),
                year_of_admission: moment().year(),
            };
            let letters = this.custom_email_letters;
            const dot = ".";
            
            return {
                value: formatString,
                label: `${eval(formatString)
                    .toLowerCase()
                    .replace(/[^\.a-z0-9]/g, "")}@${domain}${extra}`,
                type: 'custom'
            };			
        },
    }, 
        
    
    data() {
        return {
            student_rule_object: {
                active: null,
                match: null,
                rules: null,
            },
            employee_rule_object: {
                active: null,
            },
            form: null,
            loading: false,
            custom_email_letters: "",
            value: "",
            isPasswordVisible: false,
            passwordPolicies: [
                {
                    label: "Four-digit passcode",
                    value: 4,
                },
                {
                    label: "Six-digit passcode",
                    value: 6,
                },
                {
                    label: "Eight or more numbers and letters password",
                    value: 8,
                },
            ],
            misLabel: "MIS/SIS",
            personIdOptions: {
                student: [
                    {
                        label: "Primary MIS/SIS ID",
                        value: "mis_id"
                    },
                    {
                        label: "Secondary MIS/SIS ID",
                        value: "mis_secondary_id"
                    },
                    {
                        label: "Edusync ID",
                        value: "edusync_id"
                    },
                ],
                employee: [
                    {
                        label: "Primary MIS/SIS ID",
                        value: "mis_id"
                    },
                    {
                        label: "Secondary MIS/SIS ID",
                        value: "mis_secondary_id"
                    },
                    {
                        label: "Edusync ID",
                        value: "edusync_id"
                    },
                    {
                        label: "Teacher ID",
                        value: "teacher_id"
                    },
                    
                ]
            },
             dbFields: {
                course: {
                    "course_id": "course-id",
				    "class_name": "class-name",
                    "course_code": "course-code",
                    "class_code": "class-code",
                    "custom_value": "site-number",
                },
                location: {
                    "school_id": "edusync-id",
                    "custom_value": "site-number",
                    "location_name": "location-name",
                },
                class: {
                    "class_id": "class-id",
				    "class_name": "class-name",
                    "class_code": "class-code",
                    "class_mis_id": "class-mis-id",
                    "class_description": "class-description",
                    "class_subject_id": "class-subject-id",
                    "class_subject_code": "class-subject-code",
                    "class_subject_name": "class-subject-name",
                    "custom_value": "site-number",
                },
                roster: {
                    "roster_id": "roster-id",
                    "class_id": "class-id",
                    "course_id": "course-id",
                    "course_code": "course-code",
                    "class_code": "class-code",
                    "custom_value": "site-number",
                    "person_id": "person-id",
                }
            },
            fieldNames: {
                course: {
                    "course-id": {
                        label: "Course ID",
                        value: "course_id"
                    },
                    "class-name": {
                        label: "Class name",
                        value: "class_name"
                    },
                    "course-code": {
                        label: "Course code",
                        value: "course_code"
                    },
                    "class-code": {
                        label: "Class code",
                        value: "class_code"
                    },
                    "site-number": {
                        label: "Site number",
                        value: "custom_value"
                    }
                },
                location: {
                    "edusync-id": {
                        label: "Edusync ID",
                        value: "school_id"
                    },
                    "site-number": {
                        label: "Site number",
                        value: "custom_value"
                    },
                    "location-name": {
                        label: "Location name",
                        value: "location_name"
                    }
                },
                class: {
                    "class-id": {
                        label: "Class ID",
                        value: "class_id"
                    },
                    "class-name": {
                        label: "Class name",
                        value: "class_name"
                    },
                    "class-code": {
                        label: "Class code",
                        value: "class_code"
                    },
                    "class-mis-id": {
                        label: "Class MIS ID",
                        value: "class_mis_id"
                    },
                    "class-description": {
                        label: "Class description",
                        value: "class_description"
                    },
                    "class-subject-id": {
                        label: "Class subject ID",
                        value: "class_subject_id"
                    },
                    "class-subject-code": {
                        label: "Class subject code",
                        value: "class_subject_code"
                    },
                    "class-subject-name": {
                        label: "Class subject name",
                        value: "class_subject_name"
                    },
                    "site-number": {
                        label: "Site number",
                        value: "custom_value"
                    },
                },
                roster: {
                    "roster-id": {
                        label: "Roster ID",
                        value: "roster_id"
                    },
                    "class-id": {
                        label: "Class ID",
                        value: "class_id"
                    },
                    "class-code": {
                        label: "Class code",
                        value: "class_code"
                    },
                    "course-id": {
                        label: "Course ID",
                        value: "course_id"
                    },
                    "course-code": {
                        label: "Course code",
                        value: "course_code"
                    },
                    "site-number": {
                        label: "Site number",
                        value: "custom_value"
                    },
                    "person-id": {
                        label: "Person ID",
                        value: "person_id"
                    }
                }
            },
            userEmailOptions: [
                {
                    label: "Primary email",
                    value: "email_primary"
                },
                {
                    label: "Email",
                    value: "email"
                },
                {
                    label: "Work email",
                    value: "email_work"
                },
            ],
            userEmailAccountCreationOptions: {
                student: [
                    {
                        label: "Ignore students without an email address",
                        value: "ignore_empty"
                    },
                    {
                        label: "Always use a generated email address",
                        value: "use_generated"
                    },
                    {
                        label: "Use a generated email address only for students without an email address",
                        value: "use_generated_if_empty"
                    },
                ],
                employee: [
                    {
                        label: "Ignore staff without an email address",
                        value: "ignore_empty"
                    },
                    {
                        label: "Always use a generated email address",
                        value: "use_generated"
                    },
                    {
                        label: "Use a generated email address only for staff without an email address",
                        value: "use_generated_if_empty"
                    },
                ],
            }
        };
    },
};
</script>
